import { CheckCircle, ClipboardCheck, ClipboardList, ClipboardX, FileSearch, Files, Hourglass, Upload, XCircle } from "lucide-react";
import type { DashboardSummary } from "../../api/dashboardApi";
import { KpiCard, KpiGrid, type KpiTone } from "../KpiCard";

type Card = { label: string; value: number | undefined; href: string; icon: typeof Files; tone: KpiTone };

function Cards({ cards, columns }: { cards: Card[]; columns: string }) {
  return (
    <KpiGrid className={`grid-cols-1 sm:grid-cols-2 ${columns}`}>
      {cards.map((card) => (
        <KpiCard key={card.label} tone={card.tone} icon={card.icon} label={card.label} value={card.value ?? 0} href={card.href} />
      ))}
    </KpiGrid>
  );
}

/**
 * Accès rapide : 5 cartes de factures (toutes, soumises, en examen, approuvées, rejetées), puis 4 cartes de demandes
 * de validation (toutes, en attente, approuvées, rejetées). Chaque carte ouvre la liste correspondante.
 */
export function DashboardStatusCards({ summary }: { summary: DashboardSummary | null }) {
  const invoices = summary?.invoices;
  const requests = summary?.requests;

  return (
    <div className="space-y-4">
      <Cards
        columns="lg:grid-cols-5"
        cards={[
          { label: "Toutes les factures", value: invoices?.total, href: "/dashboard/invoices", icon: Files, tone: "sky" },
          { label: "Factures soumises", value: invoices?.submitted, href: "/dashboard/invoices?status=submitted", icon: Upload, tone: "amber" },
          { label: "Factures en examen", value: invoices?.in_review, href: "/dashboard/invoices?status=inReview", icon: FileSearch, tone: "purple" },
          { label: "Factures approuvées", value: invoices?.approved, href: "/dashboard/invoices/approved", icon: CheckCircle, tone: "mint" },
          { label: "Factures rejetées", value: invoices?.rejected, href: "/dashboard/invoices/rejected", icon: XCircle, tone: "red" },
        ]}
      />
      <Cards
        columns="lg:grid-cols-4"
        cards={[
          { label: "Toutes les demandes", value: requests?.total, href: "/dashboard/requests", icon: ClipboardList, tone: "slate" },
          { label: "Demandes en attente", value: requests?.pending, href: "/dashboard/requests?status=pending", icon: Hourglass, tone: "amber" },
          { label: "Demandes approuvées", value: requests?.approved, href: "/dashboard/requests?status=approved", icon: ClipboardCheck, tone: "lime" },
          { label: "Demandes rejetées", value: requests?.rejected, href: "/dashboard/requests?status=rejected", icon: ClipboardX, tone: "pink" },
        ]}
      />
    </div>
  );
}
